import { Link } from 'react-router-dom'
import { ArrowUpRightIcon } from '@heroicons/react/24/outline'
import { H2, H3, SmallParagraph, SmallText } from '../../components/typography/Typography'
import { ANALYTICS_EVENTS, track } from '../../lib/analytics'
import indiaGate from '../../assets/india-gate-3.webp'
import orana from '../../assets/orana.webp'
import chandigarh from '../../assets/strawberryfields.webp'

// `slug` is both the job reference route and the analytics label for the card.
const projects = [
    { slug: 'republic-day', title: 'Republic Day Celebrations 2023', location: 'Kartavya Path, New Delhi', image: indiaGate, alt: 'India Gate' },
    { slug: 'orana-conventions', title: 'Orana Conventions Center', location: 'Gurugram, Haryana', image: orana, alt: 'Orana Conventions' },
    { slug: 'strawberry-fields', title: 'Strawberry Fields School', location: 'Chandigarh', image: chandigarh, alt: 'Strawberry Fields School, Chandigarh' },
]

export const Projects = () => {
    return (
        <section className='flex flex-col gap-8'>
            <div className='flex flex-col gap-4 px-4 md:px-24'>
                <SmallText className='tracking-[0.25em] text-gray-500'>Projects</SmallText>
                <H2>Installed and running</H2>
            </div>

            {/* Cards swipe sideways on mobile and sit in a row from `sm` up. */}
            <div className='ml-4 lg:ml-0 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 sm:grid sm:grid-cols-3 sm:overflow-visible md:px-24 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
                {projects.map(({ slug, title, location, image, alt }) => (
                    <Link
                        key={slug}
                        to={`/job-references/${slug}`}
                        onClick={() => track(ANALYTICS_EVENTS.HOME_JOB_REFERENCE_CLICKED, { reference: slug })}
                        className='group flex w-[78%] shrink-0 snap-start flex-col gap-4 sm:w-auto sm:shrink'
                    >
                        <div className='relative aspect-[4/5] overflow-hidden rounded-2xl'>
                            <img
                                src={image}
                                alt={alt}
                                loading='lazy'
                                decoding='async'
                                className='h-full w-full object-cover transition-transform duration-500 group-hover:scale-105'
                            />
                            <span className='absolute bottom-4 right-4 flex size-14 items-center justify-center rounded-xl bg-white shadow-md transition-shadow group-hover:shadow-lg'>
                                <ArrowUpRightIcon className='size-6 text-gray-900' />
                            </span>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <H3 className='font-medium'>{title}</H3>
                            <SmallParagraph className='text-gray-600'>{location}</SmallParagraph>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    )
}
